var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 h-100" },
    [
      _c("template-listing-item-base", {
        attrs: {
          id: _vm.template.Id,
          name: _vm.template.Name,
          date: _vm.template.Modified,
          "can-delete": _vm.canDelete,
          "can-edit": _vm.canEdit
        },
        on: {
          "template-deleted": function($event) {
            return _vm.$emit("template-deleted", $event)
          },
          "template-selected": function($event) {
            return _vm.$emit("template-selected", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "sub-text-label",
            fn: function(ref) {
              var formattedDate = ref.formattedDate
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.resource("TemplatePrimaryListing_Item_SubTextLabel")
                    ) +
                    " " +
                    _vm._s(formattedDate) +
                    "\n        "
                )
              ]
            }
          },
          {
            key: "additional-controls",
            fn: function() {
              return [
                _vm.canShare
                  ? _c("i", {
                      staticClass:
                        "fas fa-share-alt mdb-icon-btn-warning fa-lg mr-1",
                      attrs: { "aria-hidden": "true" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.displayShareDialog = !_vm.displayShareDialog
                        }
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.displayShareDialog
        ? _c("template-share", { attrs: { "template-id": _vm.template.Id } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }